import { useContext, useMemo, useState } from 'react';
import {
	useTranslationCapManage,
	useTranslationCommonUi,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { SecurityDetailsControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/useSecurityDetailsController.ts';
import { getSecurityAllocationColumns } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/Securities/SecurityDetails/SecurityTabs/SecurityAllocationsTabPanel/securityAllocationsColumns.tsx';
import { ProgrammeSecurityAllocationTct } from '@dealstack/shared/lib/generated';
import { useMutation } from '@tanstack/react-query';
import { deleteAllocationById } from '@dealstack/frontend/app/services/securityAllocations.service.ts';

export const useSecurityAllocationsController = (hasEditorPermission?: boolean) => {
	const tCapManage = useTranslationCapManage();
	const tCommonUi = useTranslationCommonUi();

	const securityController = useContext(SecurityDetailsControllerContext);
	const { getAllocationsRequest, getSecurityDetailsRequest } = securityController;

	const deleteAllocationRequest = useMutation({
		mutationFn: deleteAllocationById,
	});

	const [showCreateDrawer, setShowCreateDrawer] = useState(false);
	const [editAllocation, setEditAllocation] = useState<ProgrammeSecurityAllocationTct | null>(
		null
	);
	const [deleteAllocation, setDeleteAllocation] = useState<ProgrammeSecurityAllocationTct | null>(
		null
	);
	const securityDetails = getSecurityDetailsRequest?.data;

	const allocationColumns = useMemo(() => {
		if (!securityDetails) {
			return [];
		}

		return getSecurityAllocationColumns({
			tCapManage,
			tCommonUi,
			handleEditClick: setEditAllocation,
			handleDeleteClick: setDeleteAllocation,
			security: securityDetails,
			hasEditorPermission,
		});
	}, [tCapManage, securityDetails, hasEditorPermission]);

	return {
		showCreateDrawer,
		setShowCreateDrawer,
		allocationColumns,
		editAllocation,
		setEditAllocation,
		deleteAllocation,
		setDeleteAllocation,
		getAllocationsRequest,
		isTableLoading: getAllocationsRequest?.isLoading,
		deleteAllocationRequest,
	};
};
